/** @file dock-manager/EmptyBays.jsx — placeholder when a site has no bays configured. */

export default function EmptyBays() {
  return (
    <div className="py-12 text-center text-sm text-slate-500" data-testid="dock-empty-bays">
      No bays configured for this site yet.
    </div>
  );
}

